import { createPageApp } from '@/lib/createPageApp'
import CenterPage from './CenterPage.vue'

createPageApp(CenterPage).mount()
